
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8aa8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8aa8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("12eZZ", function(module, exports) {
(function() {
    var base64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", crypt = {
        // Bit-wise rotation left
        rotl: function(n, b) {
            return n << b | n >>> 32 - b;
        },
        // Bit-wise rotation right
        rotr: function(n, b) {
            return n << 32 - b | n >>> b;
        },
        // Swap big-endian to little-endian and vice versa
        endian: function(n) {
            // If number given, swap endian
            if (n.constructor == Number) return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
            // Else, assume array and swap all items
            for(var i = 0; i < n.length; i++)n[i] = crypt.endian(n[i]);
            return n;
        },
        // Generate an array of any length of random bytes
        randomBytes: function(n) {
            for(var bytes = []; n > 0; n--)bytes.push(Math.floor(Math.random() * 256));
            return bytes;
        },
        // Convert a byte array to big-endian 32-bit words
        bytesToWords: function(bytes) {
            for(var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)words[b >>> 5] |= bytes[i] << 24 - b % 32;
            return words;
        },
        // Convert big-endian 32-bit words to a byte array
        wordsToBytes: function(words) {
            for(var bytes = [], b = 0; b < words.length * 32; b += 8)bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
            return bytes;
        },
        // Convert a byte array to a hex string
        bytesToHex: function(bytes) {
            for(var hex = [], i = 0; i < bytes.length; i++){
                hex.push((bytes[i] >>> 4).toString(16));
                hex.push((bytes[i] & 0xF).toString(16));
            }
            return hex.join("");
        },
        // Convert a hex string to a byte array
        hexToBytes: function(hex) {
            for(var bytes = [], c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
            return bytes;
        },
        // Convert a byte array to a base-64 string
        bytesToBase64: function(bytes) {
            for(var base64 = [], i = 0; i < bytes.length; i += 3){
                var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
                for(var j = 0; j < 4; j++)if (i * 8 + j * 6 <= bytes.length * 8) base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));
                else base64.push("=");
            }
            return base64.join("");
        },
        // Convert a base-64 string to a byte array
        base64ToBytes: function(base64) {
            // Remove non-base-64 characters
            base64 = base64.replace(/[^A-Z0-9+\/]/ig, "");
            for(var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4){
                if (imod4 == 0) continue;
                bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
            }
            return bytes;
        }
    };
    module.exports = crypt;
})();

});

parcelRegister("a74v9", function(module, exports) {
var $75ce0cb6501c8271$var$charenc = {
    // UTF-8 encoding
    utf8: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            return $75ce0cb6501c8271$var$charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            return decodeURIComponent(escape($75ce0cb6501c8271$var$charenc.bin.bytesToString(bytes)));
        }
    },
    // Binary encoding
    bin: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            for(var bytes = [], i = 0; i < str.length; i++)bytes.push(str.charCodeAt(i) & 0xFF);
            return bytes;
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            for(var str = [], i = 0; i < bytes.length; i++)str.push(String.fromCharCode(bytes[i]));
            return str.join("");
        }
    }
};
module.exports = $75ce0cb6501c8271$var$charenc;

});

parcelRegister("7B5Ea", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ // The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function(obj) {
    return obj != null && ($58805e71bbbc0b37$var$isBuffer(obj) || $58805e71bbbc0b37$var$isSlowBuffer(obj) || !!obj._isBuffer);
};
function $58805e71bbbc0b37$var$isBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function $58805e71bbbc0b37$var$isSlowBuffer(obj) {
    return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && $58805e71bbbc0b37$var$isBuffer(obj.slice(0, 0));
}

});

var $cbdf17c3d09bc906$export$863d7ca51b416cee;
var $cbdf17c3d09bc906$export$7b3cbda67be88f5f;
var $cbdf17c3d09bc906$export$ee7a15c61bfdeb11;
var $cbdf17c3d09bc906$export$f0199846ca09d4f9;
var $cbdf17c3d09bc906$var$single = $cbdf17c3d09bc906$export$863d7ca51b416cee = function(s) {
    return "'" + s.replace(/\\|'/g, function(m) {
        return "\\" + m;
    }) + "'";
};
var $cbdf17c3d09bc906$var$double = $cbdf17c3d09bc906$export$7b3cbda67be88f5f = function(s) {
    return '"' + s.replace(/\\|"/g, function(m) {
        return "\\" + m;
    }) + '"';
};
$cbdf17c3d09bc906$export$ee7a15c61bfdeb11 = function(s) {
    return /'/.test(s) ? $cbdf17c3d09bc906$var$double(s) : $cbdf17c3d09bc906$var$single(s);
};
$cbdf17c3d09bc906$export$f0199846ca09d4f9 = function(s) {
    var quote = s[0];
    var single = quote === "'";
    return s.substring(1, s.length - 1).replace(/\\\\/g, "\\").replace(single ? /\\'/g : /\\"/g, quote);
};


const $fdfd340aa13d9aca$var$nonSpaceRegex = /\S/g;
const $fdfd340aa13d9aca$var$keyEndRegex = /[\s=]/g;
function $fdfd340aa13d9aca$var$matchGRegexFrom(text, regex, index) {
    regex.lastIndex = index;
    return regex.exec(text);
}
function $fdfd340aa13d9aca$var$stringCharIsEscaped(text, index) {
    let escaped = false;
    while(index > 0){
        index -= 1;
        if (text[index] != "\\") break;
        escaped = !escaped;
    }
    return escaped;
}
function $fdfd340aa13d9aca$var$findClosingQuote(text, index) {
    // search for non escaped quote
    while(true){
        if ((index = text.indexOf('"', index)) < 0) return -1;
        if (!$fdfd340aa13d9aca$var$stringCharIsEscaped(text, index)) break;
        index += 1;
    }
    return index;
}
function $fdfd340aa13d9aca$var$parseAttributes(line, lineNumber, attributeStart) {
    const attributes = {};
    let index = attributeStart ?? line.indexOf(" ");
    if (index < 0) // no attributes
    return attributes;
    let match;
    while(match = $fdfd340aa13d9aca$var$matchGRegexFrom(line, $fdfd340aa13d9aca$var$nonSpaceRegex, index)){
        index = match.index;
        // find key end
        match = $fdfd340aa13d9aca$var$matchGRegexFrom(line, $fdfd340aa13d9aca$var$keyEndRegex, index);
        if (!match) throw new Error(`Unexpected "${line.slice(index)}" on line ${lineNumber}`);
        const key = line.slice(index, match.index);
        // find "="
        const eqIndex = line.indexOf("=", match.index);
        if (eqIndex < 0) throw new Error(`Attribute is missing "=" on line ${lineNumber}`);
        // find value start
        match = $fdfd340aa13d9aca$var$matchGRegexFrom(line, $fdfd340aa13d9aca$var$nonSpaceRegex, eqIndex + 1);
        if (!match) throw new Error(`Attribute is missing value on line ${lineNumber}`);
        // find value end
        let valueStart = match.index;
        let value = "";
        if (line[valueStart] == '"') {
            // quoted value
            let valueEnd = $fdfd340aa13d9aca$var$findClosingQuote(line, valueStart + 1);
            if (valueEnd < 0) throw new Error(`String missing closing quote on line ${lineNumber}`);
            valueEnd += 1;
            value = (0, $cbdf17c3d09bc906$export$f0199846ca09d4f9)(line.slice(valueStart, valueEnd));
            index = valueEnd;
        } else {
            // no quotes
            let valueEnd = line.indexOf(" ", valueStart);
            if (valueEnd < 0) valueEnd = line.length;
            value = line.slice(valueStart, valueEnd);
            index = valueEnd;
        }
        attributes[key] = value;
    }
    return attributes;
}
function $fdfd340aa13d9aca$var$nextWord(text, position) {
    let startIndex = text.length;
    for(let i = position ?? 0; i < text.length; i++)if (text[i] != " ") {
        startIndex = i;
        break;
    }
    let endIndex = text.length;
    for(let i = startIndex; i < text.length; i++)if (text[i] == " ") {
        endIndex = i;
        break;
    }
    return [
        startIndex,
        text.slice(startIndex, endIndex),
        text.slice(endIndex)
    ];
}
function $fdfd340aa13d9aca$export$e5a118b8056fd8d9(text) {
    const animations = [];
    const boomsheet = {
        version: "modern",
        animations: animations
    };
    let lineNumber = 0;
    let currentAnimation;
    let currentFrame;
    for (let line of text.split("\n")){
        line = line.trim();
        lineNumber += 1;
        if (line == "" || line.startsWith("#") || line.startsWith("!") || line.startsWith("imagePath") || line.startsWith("version")) continue;
        if (line.startsWith("anim ") || line.startsWith("animation ")) {
            const spaceIndex = line.indexOf(" ");
            if (spaceIndex == -1) throw new Error(`Animation is missing state name on line ${lineNumber}`);
            let [_, word, remainingLine] = $fdfd340aa13d9aca$var$nextWord(line.slice(spaceIndex));
            let state;
            if (word.startsWith("state=") || word == "state" && $fdfd340aa13d9aca$var$nextWord(remainingLine)[1].startsWith("=")) {
                // state="STATE"
                boomsheet.version = "legacy";
                const attributes = $fdfd340aa13d9aca$var$parseAttributes(line, lineNumber);
                state = attributes.state;
            } else if (word.startsWith('"')) {
                // quoted state
                remainingLine = line.slice(spaceIndex).trim();
                state = remainingLine.slice(1, $fdfd340aa13d9aca$var$findClosingQuote(remainingLine, 1));
            } else // unquoted state
            state = line.slice(spaceIndex).trim();
            if (state == undefined) throw new Error(`Animation is missing state name on line ${lineNumber}`);
            const animation = {
                state: state,
                frames: []
            };
            animations.push(animation);
            currentAnimation = animation;
        } else if (line.startsWith("frame") || line.startsWith("blank")) {
            if (!currentAnimation) throw new Error(`No animation state to associate frame with on line ${lineNumber}`);
            const attributes = $fdfd340aa13d9aca$var$parseAttributes(line, lineNumber);
            const frame = {
                x: parseFloat(attributes.x) || 0,
                y: parseFloat(attributes.y) || 0,
                w: parseFloat(attributes.w) || 0,
                h: parseFloat(attributes.h) || 0,
                originx: parseFloat(attributes.originx) || 0,
                originy: parseFloat(attributes.originy) || 0,
                flipx: parseInt(attributes.flipx) == 1,
                flipy: parseInt(attributes.flipy) == 1,
                duration: attributes.duration || attributes.dur || "",
                points: []
            };
            currentAnimation.frames.push(frame);
            currentFrame = frame;
        } else if (line.startsWith("point ")) {
            if (!currentFrame) throw new Error(`No frame to associate point with on line ${lineNumber}`);
            let attributesIndex = 6;
            // see if we start with a label in quotes or if we need to just read attributes
            const [wordIndex, word, _] = $fdfd340aa13d9aca$var$nextWord(line, attributesIndex);
            let label;
            if (word.startsWith('"')) {
                // point starts with label in quotes and not within a named attribute
                const labelEndIndex = $fdfd340aa13d9aca$var$findClosingQuote(line, wordIndex + 1);
                label = line.slice(wordIndex + 1, labelEndIndex);
                attributesIndex = labelEndIndex + 1;
            }
            // read attributes
            const attributes = $fdfd340aa13d9aca$var$parseAttributes(line, lineNumber, attributesIndex);
            label = label ?? attributes.label;
            if (!label) throw new Error(`Point is missing label on line ${lineNumber}`);
            const point = {
                label: label,
                x: parseFloat(attributes.x),
                y: parseFloat(attributes.y)
            };
            currentFrame.points.push(point);
        } else {
            const wordEnd = line.indexOf(" ");
            const word = wordEnd < 0 ? line : line.slice(0, wordEnd);
            throw new Error(`Unexpected "${word}" on line ${lineNumber}`);
        }
    }
    return boomsheet;
}
function $fdfd340aa13d9aca$var$serializeObject(name, object, options = {
    quoteAllValues: true
}) {
    const text = [
        name
    ];
    for(const key in object){
        const value = object[key];
        let renamedKey = key;
        if (options.renamedKeys) renamedKey = options.renamedKeys[key] || key;
        switch(typeof value){
            case "string":
                if (value != "") {
                    text.push(" ");
                    text.push(renamedKey);
                    text.push("=");
                    if (options.quoteAllValues || value.includes('"') || value.includes(" ")) text.push((0, $cbdf17c3d09bc906$export$7b3cbda67be88f5f)(value));
                    else text.push(value);
                }
                break;
            case "number":
                if (value != 0) {
                    if (options.quoteAllValues) text.push(` ${renamedKey}="${value}"`);
                    else text.push(` ${renamedKey}=${value}`);
                }
                break;
            case "boolean":
                if (value == true) {
                    text.push(" ");
                    text.push(renamedKey);
                    if (options.quoteAllValues) text.push('="1"');
                    else text.push("=1");
                }
                break;
            case "object":
                if (Array.isArray(value)) break;
            default:
                throw new Error(`Unexpected ${typeof value} for ${renamedKey}`);
        }
    }
    return text.join("");
}
function $fdfd340aa13d9aca$export$ea55e312597ee95e(boomsheet) {
    const lines = [];
    const options = {
        quoteAllValues: true
    };
    if (boomsheet.version == "modern") {
        options.quoteAllValues = false;
        options.renamedKeys = {
            duration: "dur"
        };
    }
    for (const animation of boomsheet.animations){
        if (boomsheet.version == "modern") lines.push("anim " + animation.state);
        else lines.push($fdfd340aa13d9aca$var$serializeObject("animation", animation, options));
        for (const frame of animation.frames){
            lines.push($fdfd340aa13d9aca$var$serializeObject("frame", frame, options));
            for (const point of frame.points)lines.push($fdfd340aa13d9aca$var$serializeObject("point", point, options));
        }
        lines.push("");
    }
    return lines.join("\n");
}


var $7bcff58d1f5524c8$exports = {};
"use strict";
var $06f5eb59911c96c0$exports = {};
/******************************************************************************

This is a binary tree based bin packing algorithm that is more complex than
the simple Packer (packer.js). Instead of starting off with a fixed width and
height, it starts with the width and height of the first block passed and then
grows as necessary to accomodate each subsequent block. As it grows it attempts
to maintain a roughly square ratio by making 'smart' choices about whether to
grow right or down.

When growing, the algorithm can only grow to the right OR down. Therefore, if
the new block is BOTH wider and taller than the current target then it will be
rejected. This makes it very important to initialize with a sensible starting
width and height. If you are providing sorted input (largest first) then this
will not be an issue.

A potential way to solve this limitation would be to allow growth in BOTH
directions at once, but this requires maintaining a more complex tree
with 3 children (down, right and center) and that complexity can be avoided
by simply chosing a sensible starting block.

Best results occur when the input blocks are sorted by height, or even better
when sorted by max(width,height).

Inputs:
------

	blocks: array of any objects that have .w and .h attributes

Outputs:
-------

	marks each block that fits with a .fit attribute pointing to a
	node with .x and .y coordinates

Example:
-------

	var blocks = [
		{ w: 100, h: 100 },
		{ w: 100, h: 100 },
		{ w:  80, h:  80 },
		{ w:  80, h:  80 },
		etc
		etc
	];

	var packer = new GrowingPacker();
	packer.fit(blocks);

	for(var n = 0 ; n < blocks.length ; n++) {
		var block = blocks[n];
		if (block.fit) {
			Draw(block.fit.x, block.fit.y, block.w, block.h);
		}
	}


******************************************************************************/ var $06f5eb59911c96c0$var$GrowingPacker = function() {};
$06f5eb59911c96c0$var$GrowingPacker.prototype = {
    fit: function(blocks) {
        var n, node, block, len = blocks.length, fit;
        var width = len > 0 ? blocks[0].width : 0;
        var height = len > 0 ? blocks[0].height : 0;
        this.root = {
            x: 0,
            y: 0,
            width: width,
            height: height
        };
        for(n = 0; n < len; n++){
            block = blocks[n];
            if (node = this.findNode(this.root, block.width, block.height)) {
                fit = this.splitNode(node, block.width, block.height);
                block.x = fit.x;
                block.y = fit.y;
            } else {
                fit = this.growNode(block.width, block.height);
                block.x = fit.x;
                block.y = fit.y;
            }
        }
    },
    findNode: function(root, width, height) {
        if (root.used) return this.findNode(root.right, width, height) || this.findNode(root.down, width, height);
        else if (width <= root.width && height <= root.height) return root;
        else return null;
    },
    splitNode: function(node, width, height) {
        node.used = true;
        node.down = {
            x: node.x,
            y: node.y + height,
            width: node.width,
            height: node.height - height
        };
        node.right = {
            x: node.x + width,
            y: node.y,
            width: node.width - width,
            height: height
        };
        return node;
    },
    growNode: function(width, height) {
        var canGrowDown = width <= this.root.width;
        var canGrowRight = height <= this.root.height;
        var shouldGrowRight = canGrowRight && this.root.height >= this.root.width + width; // attempt to keep square-ish by growing right when height is much greater than width
        var shouldGrowDown = canGrowDown && this.root.width >= this.root.height + height; // attempt to keep square-ish by growing down  when width  is much greater than height
        if (shouldGrowRight) return this.growRight(width, height);
        else if (shouldGrowDown) return this.growDown(width, height);
        else if (canGrowRight) return this.growRight(width, height);
        else if (canGrowDown) return this.growDown(width, height);
        else return null; // need to ensure sensible root starting size to avoid this happening
    },
    growRight: function(width, height) {
        this.root = {
            used: true,
            x: 0,
            y: 0,
            width: this.root.width + width,
            height: this.root.height,
            down: this.root,
            right: {
                x: this.root.width,
                y: 0,
                width: width,
                height: this.root.height
            }
        };
        var node;
        if (node = this.findNode(this.root, width, height)) return this.splitNode(node, width, height);
        else return null;
    },
    growDown: function(width, height) {
        this.root = {
            used: true,
            x: 0,
            y: 0,
            width: this.root.width,
            height: this.root.height + height,
            down: {
                x: 0,
                y: this.root.height,
                width: this.root.width,
                height: height
            },
            right: this.root
        };
        var node;
        if (node = this.findNode(this.root, width, height)) return this.splitNode(node, width, height);
        else return null;
    }
};
$06f5eb59911c96c0$exports = $06f5eb59911c96c0$var$GrowingPacker;


$7bcff58d1f5524c8$exports = function(items, options) {
    options = options || {};
    var packer = new $06f5eb59911c96c0$exports();
    var inPlace = options.inPlace || false;
    // Clone the items.
    var newItems = items.map(function(item) {
        return inPlace ? item : {
            width: item.width,
            height: item.height,
            item: item
        };
    });
    newItems = newItems.sort(function(a, b) {
        // TODO: check that each actually HAS a width and a height.
        // Sort based on the size (area) of each block.
        return b.width * b.height - a.width * a.height;
    });
    packer.fit(newItems);
    var w = newItems.reduce(function(curr, item) {
        return Math.max(curr, item.x + item.width);
    }, 0);
    var h = newItems.reduce(function(curr, item) {
        return Math.max(curr, item.y + item.height);
    }, 0);
    var ret = {
        width: w,
        height: h
    };
    if (!inPlace) ret.items = newItems;
    return ret;
};


var $fd882af322e8eaf8$exports = {};




(function() {
    var crypt = (parcelRequire("12eZZ")), utf8 = (parcelRequire("a74v9")).utf8, isBuffer = (parcelRequire("7B5Ea")), bin = (parcelRequire("a74v9")).bin, // The core
    md5 = function(message, options) {
        // Convert to byte array
        if (message.constructor == String) {
            if (options && options.encoding === "binary") message = bin.stringToBytes(message);
            else message = utf8.stringToBytes(message);
        } else if (isBuffer(message)) message = Array.prototype.slice.call(message, 0);
        else if (!Array.isArray(message) && message.constructor !== Uint8Array) message = message.toString();
        // else, assume byte array already
        var m = crypt.bytesToWords(message), l = message.length * 8, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878;
        // Swap endian
        for(var i = 0; i < m.length; i++)m[i] = (m[i] << 8 | m[i] >>> 24) & 0x00FF00FF | (m[i] << 24 | m[i] >>> 8) & 0xFF00FF00;
        // Padding
        m[l >>> 5] |= 0x80 << l % 32;
        m[(l + 64 >>> 9 << 4) + 14] = l;
        // Method shortcuts
        var FF = md5._ff, GG = md5._gg, HH = md5._hh, II = md5._ii;
        for(var i = 0; i < m.length; i += 16){
            var aa = a, bb = b, cc = c, dd = d;
            a = FF(a, b, c, d, m[i + 0], 7, -680876936);
            d = FF(d, a, b, c, m[i + 1], 12, -389564586);
            c = FF(c, d, a, b, m[i + 2], 17, 606105819);
            b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
            a = FF(a, b, c, d, m[i + 4], 7, -176418897);
            d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
            c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
            b = FF(b, c, d, a, m[i + 7], 22, -45705983);
            a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
            d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
            c = FF(c, d, a, b, m[i + 10], 17, -42063);
            b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
            a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
            d = FF(d, a, b, c, m[i + 13], 12, -40341101);
            c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
            b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
            a = GG(a, b, c, d, m[i + 1], 5, -165796510);
            d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
            c = GG(c, d, a, b, m[i + 11], 14, 643717713);
            b = GG(b, c, d, a, m[i + 0], 20, -373897302);
            a = GG(a, b, c, d, m[i + 5], 5, -701558691);
            d = GG(d, a, b, c, m[i + 10], 9, 38016083);
            c = GG(c, d, a, b, m[i + 15], 14, -660478335);
            b = GG(b, c, d, a, m[i + 4], 20, -405537848);
            a = GG(a, b, c, d, m[i + 9], 5, 568446438);
            d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
            c = GG(c, d, a, b, m[i + 3], 14, -187363961);
            b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
            a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
            d = GG(d, a, b, c, m[i + 2], 9, -51403784);
            c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
            b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
            a = HH(a, b, c, d, m[i + 5], 4, -378558);
            d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
            c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
            b = HH(b, c, d, a, m[i + 14], 23, -35309556);
            a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
            d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
            c = HH(c, d, a, b, m[i + 7], 16, -155497632);
            b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
            a = HH(a, b, c, d, m[i + 13], 4, 681279174);
            d = HH(d, a, b, c, m[i + 0], 11, -358537222);
            c = HH(c, d, a, b, m[i + 3], 16, -722521979);
            b = HH(b, c, d, a, m[i + 6], 23, 76029189);
            a = HH(a, b, c, d, m[i + 9], 4, -640364487);
            d = HH(d, a, b, c, m[i + 12], 11, -421815835);
            c = HH(c, d, a, b, m[i + 15], 16, 530742520);
            b = HH(b, c, d, a, m[i + 2], 23, -995338651);
            a = II(a, b, c, d, m[i + 0], 6, -198630844);
            d = II(d, a, b, c, m[i + 7], 10, 1126891415);
            c = II(c, d, a, b, m[i + 14], 15, -1416354905);
            b = II(b, c, d, a, m[i + 5], 21, -57434055);
            a = II(a, b, c, d, m[i + 12], 6, 1700485571);
            d = II(d, a, b, c, m[i + 3], 10, -1894986606);
            c = II(c, d, a, b, m[i + 10], 15, -1051523);
            b = II(b, c, d, a, m[i + 1], 21, -2054922799);
            a = II(a, b, c, d, m[i + 8], 6, 1873313359);
            d = II(d, a, b, c, m[i + 15], 10, -30611744);
            c = II(c, d, a, b, m[i + 6], 15, -1560198380);
            b = II(b, c, d, a, m[i + 13], 21, 1309151649);
            a = II(a, b, c, d, m[i + 4], 6, -145523070);
            d = II(d, a, b, c, m[i + 11], 10, -1120210379);
            c = II(c, d, a, b, m[i + 2], 15, 718787259);
            b = II(b, c, d, a, m[i + 9], 21, -343485551);
            a = a + aa >>> 0;
            b = b + bb >>> 0;
            c = c + cc >>> 0;
            d = d + dd >>> 0;
        }
        return crypt.endian([
            a,
            b,
            c,
            d
        ]);
    };
    // Auxiliary functions
    md5._ff = function(a, b, c, d, x, s, t) {
        var n = a + (b & c | ~b & d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._gg = function(a, b, c, d, x, s, t) {
        var n = a + (b & d | c & ~d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._hh = function(a, b, c, d, x, s, t) {
        var n = a + (b ^ c ^ d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._ii = function(a, b, c, d, x, s, t) {
        var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    // Package private blocksize
    md5._blocksize = 16;
    md5._digestsize = 16;
    $fd882af322e8eaf8$exports = function(message, options) {
        if (message === undefined || message === null) throw new Error("Illegal argument " + message);
        var digestbytes = crypt.wordsToBytes(md5(message, options));
        return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
    };
})();


const $198de2760da31229$var$padding = 1;
function $198de2760da31229$var$imageDataMatches(dataA, dataB) {
    if (!dataA || !dataB) return !dataA && !dataB;
    return dataA.data.every((b, i)=>b == dataB.data[i]);
}
function $198de2760da31229$var$matchBin(binMap, key, frame, imageData) {
    let matchingBins = binMap[key];
    if (!matchingBins) {
        matchingBins = [];
        binMap[key] = matchingBins;
    }
    for (const bin of matchingBins){
        if (bin.frames[0].w != frame.w || bin.frames[0].h != frame.h) continue;
        if (!$198de2760da31229$var$imageDataMatches(bin.imageData, imageData)) continue;
        return bin;
    }
}
function $198de2760da31229$var$getImageIndex(w, x, y) {
    return (y * w + x) * 4;
}
function $198de2760da31229$export$2e2bcd8739ae039(destCanvas, sourceCanvas, animations) {
    const sourceCtx = sourceCanvas.getContext("2d");
    const binMap = {};
    for (const animation of animations)for (const frame of animation.frames){
        if (frame.w == 0 && frame.h == 0) continue;
        const imageData = sourceCtx.getImageData(frame.x, frame.y, frame.w, frame.h);
        const key = (0, (/*@__PURE__*/$parcel$interopDefault($fd882af322e8eaf8$exports)))(imageData.data);
        let matchingBin = $198de2760da31229$var$matchBin(binMap, key, frame, imageData);
        if (!matchingBin) {
            // try flipped, only on the x axis since it's common
            const flippedImageData = sourceCtx.getImageData(frame.x, frame.y, frame.w, frame.h);
            for(let y = 0; y < frame.h; y++)for(let x = 0; x < frame.w; x++){
                const i = $198de2760da31229$var$getImageIndex(frame.w, x, y);
                const flippedI = $198de2760da31229$var$getImageIndex(frame.w, frame.w - x - 1, y);
                for(let j = 0; j < 4; j++)flippedImageData.data[i + j] = imageData.data[flippedI + j];
            }
            const flippedKey = (0, (/*@__PURE__*/$parcel$interopDefault($fd882af322e8eaf8$exports)))(flippedImageData.data);
            matchingBin = $198de2760da31229$var$matchBin(binMap, flippedKey, frame, flippedImageData);
            if (matchingBin) {
                frame.flipx = !frame.flipx;
                frame.originx = frame.w - frame.originx;
            }
        }
        if (matchingBin) matchingBin.frames.push(frame);
        else binMap[key].push({
            frames: [
                frame
            ],
            imageData: imageData,
            width: frame.w + $198de2760da31229$var$padding * 2,
            height: frame.h + $198de2760da31229$var$padding * 2
        });
    }
    // pack
    const bins = Object.values(binMap).flat();
    const packResult = (0, (/*@__PURE__*/$parcel$interopDefault($7bcff58d1f5524c8$exports)))(bins);
    // update frames and render
    destCanvas.width = packResult.width;
    destCanvas.height = packResult.height;
    const ctx = destCanvas.getContext("2d");
    for (const item of packResult.items){
        const { frames: frames } = item.item;
        const frame = item.item.frames[0];
        const destX = item.x + $198de2760da31229$var$padding;
        const destY = item.y + $198de2760da31229$var$padding;
        ctx.drawImage(sourceCanvas, frame.x, frame.y, frame.w, frame.h, destX, destY, frame.w, frame.h);
        for (const frame of frames){
            frame.x = destX;
            frame.y = destY;
        }
    }
    return animations;
}


function $a9cec9f5d2c68d09$export$cc0e7cb90ac4067f(file) {
    return new Promise((resolve, reject)=>{
        // load file as data url, then load as image
        const reader = new FileReader();
        reader.onload = function() {
            // load image
            const image = new Image();
            image.src = reader.result;
            image.onload = function() {
                resolve(image);
            };
            image.onerror = function() {
                reject(new Error(`Failed to load "${file.name}"`));
            };
        };
        reader.onerror = function() {
            reject(new Error(`Failed to load "${file.name}: ${reader.error}"`));
        };
        reader.readAsDataURL(file);
    });
}
function $a9cec9f5d2c68d09$export$b4f0996f721d43ec(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(new Error(`Failed to load "${file.name}: ${reader.error}"`));
        };
        reader.readAsText(file);
    });
}


class $d56fe29905c32fe3$export$2e2bcd8739ae039 {
    resolveOutputVersion() {
        if (this.sheets.some((sheet)=>sheet.boomsheet?.version == "modern")) return "modern";
        return "legacy";
    }
    findOrInsert(name) {
        let entry = this.sheets.find((data)=>data.name == name);
        if (entry) return entry;
        entry = {
            name: name
        };
        this.sheets.push(entry);
        return entry;
    }
    remove(name) {
        const index = this.sheets.findIndex((data)=>data.name == name);
        this.sheets.splice(index, 1);
    }
    constructor(){
        this.sheets = [];
    }
}



const $6954894cfc5c8565$var$padding = 1;
function $6954894cfc5c8565$export$2e2bcd8739ae039(canvas, inputSheets) {
    const animations = [];
    const bins = [];
    // clone animations into a single array and create bins
    for (const sheet of inputSheets.sheets){
        if (!sheet.animations || !sheet.image) continue;
        const clonedSheetAnimations = structuredClone(sheet.animations);
        animations.push(...clonedSheetAnimations);
        for (const animation of clonedSheetAnimations)for (const frame of animation.frames){
            if (frame.w == 0 || frame.h == 0) continue;
            bins.push({
                image: sheet.image,
                frame: frame,
                width: frame.w + $6954894cfc5c8565$var$padding * 2,
                height: frame.h + $6954894cfc5c8565$var$padding * 2
            });
        }
    }
    // pack
    const packResult = (0, (/*@__PURE__*/$parcel$interopDefault($7bcff58d1f5524c8$exports)))(bins);
    // update frames and render
    canvas.width = packResult.width;
    canvas.height = packResult.height;
    const ctx = canvas.getContext("2d");
    for (const item of packResult.items){
        const frame = item.item.frame;
        const destX = item.x + $6954894cfc5c8565$var$padding;
        const destY = item.y + $6954894cfc5c8565$var$padding;
        ctx.drawImage(item.item.image, frame.x, frame.y, frame.w, frame.h, destX, destY, frame.w, frame.h);
        frame.x = destX;
        frame.y = destY;
    }
    return animations;
}



function $229918b413359bbd$var$subtractDuration(a, b) {
    return "frames" in a && "frames" in b ? {
        frames: a.frames - b.frames
    } : {
        seconds: $229918b413359bbd$var$durationAsSecs(a) - $229918b413359bbd$var$durationAsSecs(b)
    };
}
function $229918b413359bbd$var$durationAsSecs(duration) {
    // assuming 60 fps
    return "frames" in duration ? duration.frames / 60 : duration.seconds;
}
function $229918b413359bbd$var$parseDuration(duration) {
    duration = duration.trim();
    return duration.toLowerCase().endsWith("f") ? {
        frames: parseInt(duration.slice(0, -1))
    } : {
        seconds: parseFloat(duration) || 0
    };
}
const $229918b413359bbd$var$padding = 1;
function $229918b413359bbd$export$2e2bcd8739ae039(canvas, inputSheets) {
    const binMap = {};
    // clone animations into a single array and create bins
    for(let sheetI = 0; sheetI < inputSheets.sheets.length; sheetI++){
        const sheet = inputSheets.sheets[sheetI];
        if (!sheet.animations || !sheet.image) continue;
        for (const animation of sheet.animations){
            let stateBins = binMap[animation.state];
            if (!stateBins) {
                stateBins = [];
                binMap[animation.state] = stateBins;
            }
            let i = 0;
            for (const frame of animation.frames){
                let remainingDuration = $229918b413359bbd$var$parseDuration(frame.duration) || 0; // || 0 to handle NaN
                let emptyDuration = $229918b413359bbd$var$durationAsSecs(remainingDuration) == 0;
                // overlay this frame as long as we have the duration to do so
                while(emptyDuration || $229918b413359bbd$var$durationAsSecs(remainingDuration) > 0){
                    emptyDuration = false;
                    let existingBin = stateBins[i];
                    i += 1;
                    if (!existingBin) {
                        // create a new bin
                        const lastOverlayed = stateBins[stateBins.length - 1]?.overlayed || [];
                        stateBins.push({
                            overlayed: [
                                // extend the last frame
                                ...lastOverlayed.filter(({ sheetIndex: sheetIndex })=>sheetIndex != sheetI),
                                {
                                    sheetIndex: sheetI,
                                    frame: frame
                                }
                            ],
                            outFrame: {
                                x: 0,
                                y: 0,
                                w: frame.w,
                                h: frame.h,
                                originx: frame.originx,
                                originy: frame.originy,
                                flipx: false,
                                flipy: false,
                                duration: "",
                                points: []
                            },
                            duration: remainingDuration,
                            width: 0,
                            height: 0
                        });
                        break;
                    }
                    // a bin already exists, time to overlay
                    if (existingBin.duration > remainingDuration) {
                        // split this bin in two, since this overlay only applies to part of this duration
                        const nextBin = structuredClone(existingBin);
                        nextBin.duration = $229918b413359bbd$var$subtractDuration(nextBin.duration, remainingDuration);
                        // we'd increment i, but it was already incremented above
                        stateBins.splice(i, 0, nextBin);
                        existingBin.duration = remainingDuration;
                    }
                    remainingDuration = $229918b413359bbd$var$subtractDuration(remainingDuration, existingBin.duration);
                    existingBin.overlayed.push({
                        sheetIndex: sheetI,
                        frame: frame
                    });
                }
            }
            // repeat the last frame over the remaining outFrames
            const lastFrame = animation.frames[animation.frames.length - 1];
            if (lastFrame) for(; i < stateBins.length; i++){
                const bin = stateBins[i];
                bin.overlayed.push({
                    sheetIndex: sheetI,
                    frame: lastFrame
                });
            }
        }
    }
    // resolve outFrame sizes and origin
    const bins = Object.values(binMap).flat();
    for (const bin of bins){
        // resolve origin
        for (const { frame: frame } of bin.overlayed){
            bin.outFrame.originx = Math.max(bin.outFrame.originx, frame.originx);
            bin.outFrame.originy = Math.max(bin.outFrame.originy, frame.originy);
        }
        // add points
        for (const { frame: frame } of bin.overlayed){
            const originShiftX = bin.outFrame.originx - frame.originx;
            const originShiftY = bin.outFrame.originy - frame.originy;
            for (let point of frame.points){
                point = structuredClone(point);
                point.x += originShiftX;
                point.y += originShiftY;
                bin.outFrame.points.push(point);
            }
        }
        // resolve size
        for (const { frame: frame } of bin.overlayed){
            bin.outFrame.w = Math.max(bin.outFrame.w, bin.outFrame.originx - frame.originx + frame.w);
            bin.outFrame.h = Math.max(bin.outFrame.h, bin.outFrame.originy - frame.originy + frame.h);
        }
        bin.width = bin.outFrame.w + $229918b413359bbd$var$padding * 2;
        bin.height = bin.outFrame.h + $229918b413359bbd$var$padding * 2;
    }
    // pack
    const packResult = (0, (/*@__PURE__*/$parcel$interopDefault($7bcff58d1f5524c8$exports)))(bins);
    // update outFrames and render
    canvas.width = packResult.width;
    canvas.height = packResult.height;
    const ctx = canvas.getContext("2d");
    for (const item of packResult.items){
        const destX = item.x + $229918b413359bbd$var$padding;
        const destY = item.y + $229918b413359bbd$var$padding;
        const { outFrame: outFrame } = item.item;
        outFrame.x = destX;
        outFrame.y = destY;
        const duration = item.item.duration;
        outFrame.duration = "frames" in duration ? duration.frames + "f" : duration.seconds.toString();
        for (const { sheetIndex: sheetIndex, frame: frame } of item.item.overlayed){
            const image = inputSheets.sheets[sheetIndex].image;
            if (!image) continue;
            const destX = outFrame.x + outFrame.originx - frame.originx;
            const destY = outFrame.y + outFrame.originy - frame.originy;
            ctx.save();
            ctx.translate(destX, destY);
            if (frame.flipx) {
                ctx.translate(frame.w, 0);
                ctx.scale(-1, 1);
            }
            if (frame.flipy) {
                ctx.translate(frame.h, 0);
                ctx.scale(1, -1);
            }
            ctx.drawImage(image, frame.x, frame.y, frame.w, frame.h, 0, 0, frame.w, frame.h);
            ctx.restore();
        }
    }
    // generate animation from bin map
    const animations = Object.entries(binMap).map(([state, bins])=>({
            state: state,
            frames: bins.map((bin)=>bin.outFrame)
        }));
    return animations;
}


const $9e92fc4633178fef$var$listElement = document.getElementById("sheet-list");
function $9e92fc4633178fef$export$2f6a0a63782b48a(inputSheets) {
    const itemTemplate = document.getElementById("sheet-list-item-template");
    $9e92fc4633178fef$var$listElement.textContent = "";
    for (const entry of inputSheets.sheets){
        const itemElement = itemTemplate.content.cloneNode(true);
        // set name
        const nameElement = itemElement.querySelector(".sheet-name");
        nameElement.innerText = entry.name;
        // set error
        if (!entry.image || !entry.animations) {
            const errorElement = itemElement.querySelector(".error-text");
            if (entry.animationError) errorElement.innerText = entry.animationError;
            else if (entry.imageError) errorElement.innerText = entry.imageError;
            else if (!entry.animations) errorElement.innerText = "Missing .animation file";
            else if (!entry.image) errorElement.innerText = "Missing image file";
        }
        // remove handler
        const removeEntryElement = itemElement.querySelector(".remove-file-button");
        removeEntryElement.onclick = function() {
            inputSheets.remove(entry.name);
            $9e92fc4633178fef$export$2f6a0a63782b48a(inputSheets);
        };
        // append
        $9e92fc4633178fef$var$listElement.appendChild(itemElement);
    }
}


function $257a09ef2c1454b7$var$getImageIndex(w, x, y) {
    return (y * w + x) * 4;
}
function $257a09ef2c1454b7$export$2e2bcd8739ae039(sourceCanvas, animations) {
    const sourceCtx = sourceCanvas.getContext("2d");
    // clone to avoid modifying the source animations
    animations = structuredClone(animations);
    for (const animation of animations)for (const frame of animation.frames){
        if (frame.w == 0 && frame.h == 0) continue;
        const imageData = sourceCtx.getImageData(frame.x, frame.y, frame.w, frame.h);
        const dataW = frame.w;
        const dataH = frame.h;
        const originalX = frame.x;
        const originalY = frame.y;
        // trim top
        outer: for(let y = 0; y < dataH; y++){
            for(let x = 0; x < dataW; x++){
                const transparent = imageData.data[$257a09ef2c1454b7$var$getImageIndex(dataW, x, y) + 3] == 0;
                if (!transparent) break outer;
            }
            frame.y++;
            frame.h--;
        }
        // trim bottom
        const yShift = frame.y - originalY;
        outer: for(let y = dataH - 1; y >= yShift; y--){
            for(let x = 0; x < dataW; x++){
                const transparent = imageData.data[$257a09ef2c1454b7$var$getImageIndex(dataW, x, y) + 3] == 0;
                if (!transparent) break outer;
            }
            frame.h--;
        }
        // trim left
        outer: for(let x = 0; x < dataW; x++){
            for(let y = yShift; y < yShift + frame.h; y++){
                const transparent = imageData.data[$257a09ef2c1454b7$var$getImageIndex(dataW, x, y) + 3] == 0;
                if (!transparent) break outer;
            }
            frame.x++;
            frame.w--;
        }
        // trim right
        const xShift = frame.x - originalX;
        outer: for(let x = dataW - 1; x >= xShift; x--){
            for(let y = yShift; y < yShift + frame.h; y++){
                const transparent = imageData.data[$257a09ef2c1454b7$var$getImageIndex(dataW, x, y) + 3] == 0;
                if (!transparent) break outer;
            }
            frame.w--;
        }
        // update points
        frame.originx -= xShift;
        frame.originy -= yShift;
        for (const point of frame.points){
            point.x -= xShift;
            point.y -= yShift;
        }
    }
    return animations;
}


const $b4e14b6b8da86996$var$inputSheets = new (0, $d56fe29905c32fe3$export$2e2bcd8739ae039)();
function $b4e14b6b8da86996$var$logError(error) {
    console.error(error);
    alert(error);
}
document.getElementById("clear-button").onclick = function() {
    $b4e14b6b8da86996$var$inputSheets.sheets = [];
    (0, $9e92fc4633178fef$export$2f6a0a63782b48a)($b4e14b6b8da86996$var$inputSheets);
};
document.getElementById("overlay-button").onclick = function() {
    const canvas = document.querySelector("#output canvas");
    const textarea = document.querySelector("#output textarea");
    try {
        const offscreenCanvas = document.createElement("canvas");
        const animations = (0, $229918b413359bbd$export$2e2bcd8739ae039)(offscreenCanvas, $b4e14b6b8da86996$var$inputSheets);
        (0, $198de2760da31229$export$2e2bcd8739ae039)(canvas, offscreenCanvas, animations);
        const boomsheet = {
            version: $b4e14b6b8da86996$var$inputSheets.resolveOutputVersion(),
            animations: animations
        };
        textarea.value = (0, $fdfd340aa13d9aca$export$ea55e312597ee95e)(boomsheet);
    } catch (error) {
        $b4e14b6b8da86996$var$logError(error);
    }
};
const $b4e14b6b8da86996$var$trimFramesCheckbox = document.getElementById("trim-frames");
document.getElementById("merge-button").onclick = function() {
    const canvas = document.querySelector("#output canvas");
    const textarea = document.querySelector("#output textarea");
    try {
        const offscreenCanvas = document.createElement("canvas");
        // initialize canvas context settings
        offscreenCanvas.getContext("2d", {
            willReadFrequently: true
        });
        let animations = (0, $6954894cfc5c8565$export$2e2bcd8739ae039)(offscreenCanvas, $b4e14b6b8da86996$var$inputSheets);
        if ($b4e14b6b8da86996$var$trimFramesCheckbox.checked) animations = (0, $257a09ef2c1454b7$export$2e2bcd8739ae039)(offscreenCanvas, animations);
        (0, $198de2760da31229$export$2e2bcd8739ae039)(canvas, offscreenCanvas, animations);
        const boomsheet = {
            version: $b4e14b6b8da86996$var$inputSheets.resolveOutputVersion(),
            animations: animations
        };
        textarea.value = (0, $fdfd340aa13d9aca$export$ea55e312597ee95e)(boomsheet);
    } catch (error) {
        $b4e14b6b8da86996$var$logError(error);
    }
};
document.body.addEventListener("dragover", (event)=>event.preventDefault());
document.body.addEventListener("drop", (event)=>{
    const items = event.dataTransfer?.items;
    if (!items) return;
    event.preventDefault();
    const files = [];
    for (const item of items){
        const file = item.getAsFile();
        if (file) files.push(file);
    }
    $b4e14b6b8da86996$var$loadFiles(files).catch($b4e14b6b8da86996$var$logError).finally(()=>{
        (0, $9e92fc4633178fef$export$2f6a0a63782b48a)($b4e14b6b8da86996$var$inputSheets);
    });
});
function $b4e14b6b8da86996$var$baseName(name) {
    return name.slice(0, name.lastIndexOf("."));
}
async function $b4e14b6b8da86996$var$loadFiles(files) {
    for (const file of files){
        const name = $b4e14b6b8da86996$var$baseName(file.name);
        const entry = $b4e14b6b8da86996$var$inputSheets.findOrInsert(name);
        if (file.name.endsWith(".png")) try {
            entry.image = await (0, $a9cec9f5d2c68d09$export$cc0e7cb90ac4067f)(file);
            entry.imageError = undefined;
        } catch (error) {
            console.error(error);
            entry.imageError = error.toString();
        }
        else if (file.name.endsWith(".animation") || file.name.endsWith(".anim")) try {
            const text = await (0, $a9cec9f5d2c68d09$export$b4f0996f721d43ec)(file);
            entry.boomsheet = (0, $fdfd340aa13d9aca$export$e5a118b8056fd8d9)(text);
            entry.animations = entry.boomsheet.animations;
            entry.animationError = undefined;
        } catch (error) {
            console.error(error);
            entry.animationError = error.toString();
        }
    }
}


//# sourceMappingURL=index.bd044350.js.map
